import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSite } from '../contexts/SiteContext';

const SITE_URL = process.env.REACT_APP_BACKEND_URL || '';

export function SEO({ title, description, image, url, type = 'website', article }) {
  const { settings } = useSite();
  const siteName = settings.site_name || 'Greg\'s Stuff';
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const metaDescription = description || settings.site_description || settings.site_tagline || 'DIY, Tech, and Solar projects — work, play, and everything else.';
  const metaImage = image || settings.seo_image || '';
  const canonicalUrl = url ? `${SITE_URL}${url}` : SITE_URL;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:site_name" content={siteName} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      {metaImage && <meta property="og:image" content={metaImage} />}

      {/* Twitter Card */}
      <meta name="twitter:card" content={metaImage ? 'summary_large_image' : 'summary'} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      {metaImage && <meta name="twitter:image" content={metaImage} />}

      {/* Article-specific */}
      {article?.publishedTime && <meta property="article:published_time" content={article.publishedTime} />}
      {article?.modifiedTime && <meta property="article:modified_time" content={article.modifiedTime} />}
      {article?.tags?.map((tag, i) => (
        <meta key={i} property="article:tag" content={tag} />
      ))}
      {article?.section && <meta property="article:section" content={article.section} />}
    </Helmet>
  );
}
